/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MouseRight = [
  ["path", { d: "M12 7.318V10" }],
  ["path", { d: "M19 10v5a7 7 0 0 1-14 0V9c0-3.527 2.608-6.515 6-7" }],
  ["circle", { cx: "17", cy: "4", r: "2" }]
];

export { MouseRight as default };
//# sourceMappingURL=mouse-right.js.map
